var f = function(event) {
  var currentTarget = event.currentTarget
  var tab_id = currentTarget.dataset.tab;
  
  let elements = document.querySelectorAll('div.custom-background-tabs li[data-tab]');
  elements.forEach((element) => {
    element.classList.remove('current');
    if(element.dataset.tab === tab_id) {
      element.classList.add('current');
    }
  })

  let containerTab = document.querySelector('.product-more-info-tab-content.current');
  containerTab.classList.remove('current')
  containerTab.removeAttribute('open');

  let containerTabNew = document.getElementById(tab_id);
  containerTabNew.classList.add('current');
  containerTabNew.setAttribute('open', true);
}
document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('div.custom-background-tabs li[data-tab], div.custom-background-tabs span[data-tab]');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', f);
    trigger.addEventListener('tap', f);
  });
  let containerTab = document.querySelector('.product-more-info-tab-content.current');
  containerTab.setAttribute('open', true);
});